export const vammoLangSettings = {
  digitalTwinSingleLabel: "inventory:tabs.battery.single_label",
  digitalTwinLabel: "inventory:tabs.battery.label",
  digitalTwinAddResource: "inventory:tabs.battery.add_resource",
};
